import { render } from "./ReplyTenantIcon.vue?vue&type=template&id=5d2e5a4e&ts=true"
import script from "./ReplyTenantIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyTenantIcon.vue?vue&type=script&lang=ts&setup=true"

import "./ReplyTenantIcon.vue?vue&type=style&index=0&id=5d2e5a4e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyTenantIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d2e5a4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d2e5a4e', __exports__)) {
    api.reload('5d2e5a4e', __exports__)
  }
  
  module.hot.accept("./ReplyTenantIcon.vue?vue&type=template&id=5d2e5a4e&ts=true", () => {
    api.rerender('5d2e5a4e', render)
  })

}


export default __exports__